import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/settings/profile")({
  head: () => ({ meta: [{ title: "Profile | Settings" }] }),
  component: lazyRouteComponent(() => import("@/pages-lazy/admin-settings-profile")),
});
